import React from "react";
import GoogleMapReact from "google-map-react";
import RoomIcon from "@material-ui/icons/Room";

function Maps({ lat, long }) {
  return (
    <div style={{ width: "100%", height: 250, marginTop: 95 }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyC2y1Qoj348lLHL7zqfMmGpB11g_1n8cdE" }}
        defaultCenter={{
          lat: +lat,
          lng: +long,
        }}
        defaultZoom={14}
      >
        <RoomIcon color="primary" lat={lat} lng={long} />
      </GoogleMapReact>
    </div>
  );
}

export default React.memo(Maps);
